import PropTypes from 'prop-types';
import React from 'react';
import classnames from 'classnames';

function directionDerivedValues(direction) {
    // Returns an object with string values derived from the value of
    // this.props.direction.
    const icon = direction === 1 ? 'plus-light' : 'minus';
    const aural = direction === 1 ? 'in' : 'out';
    return {
        iconClassSuffix: icon,
        // FIXME: Poorly named.
        auralSpanText: aural,
    };
}

function ZoomButton(props) {
    const derivedVals = directionDerivedValues(props.direction);
    const anchorClasses = classnames(
        'cl-icon',
        'cl-icon-' + derivedVals.iconClassSuffix
    );
    return (
        <button className={anchorClasses} onClick={props.clickHandler}>
            <span className="aural">Zoom {derivedVals.auralSpanText}:</span>
        </button>
    );
}
ZoomButton.propTypes = {
    clickHandler: PropTypes.func,
    direction: PropTypes.number.isRequired,
};

export default class Zoom extends React.Component {
    static propTypes = {
        content: PropTypes.object.isRequired,
        zoomLevel: PropTypes.number.isRequired,
        setZoom: PropTypes.func.isRequired,
    };

    handleZoomIn = e => {
        return this.zoomBy(0.1);
    };

    handleZoomOut = e => {
        return this.zoomBy(-0.1);
    };

    zoomBy = amount => {
        // Converting to fixed precision as a string, then parsing the float
        // back out to avoid floating point weirdness.
        let newZoomLevel = (this.props.zoomLevel + amount).toFixed(1);
        newZoomLevel = parseFloat(newZoomLevel);
        this.props.setZoom(this.props.content, newZoomLevel);
    };

    render() {
        const zoom = Math.floor(this.props.zoomLevel * 100) + '%';
        return (
            <div className="zoom-control">
                Zoom
                <ZoomButton direction={-1} clickHandler={this.handleZoomOut} />
                {zoom}
                <ZoomButton direction={1} clickHandler={this.handleZoomIn} />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/engage_reader/navbar/reader_menu/zoom.jsx